import React from 'react';
import { DocxIcon } from '@/components/Icons/FileIcons/DocxIcon';
import { FileIcon } from '@/components/Icons/FileIcons/FileIcon';
import { JpgIcon } from '@/components/Icons/FileIcons/JpgIcon';
import { PdfIcon } from '@/components/Icons/FileIcons/PdfIcon';
import { PngIcon } from '@/components/Icons/FileIcons/PngIcon';
import type { IconComponentProps } from '@/types/components';
import type { FileType } from '@/utils/file';

interface Props extends IconComponentProps {
  type: FileType;
}

export const FileTypeIcon: React.FC<Props> = ({ type, className }) => {
  switch (type) {
    case 'pdf':
      return <PdfIcon className={className} />;
    case 'docx':
      return <DocxIcon className={className} />;
    case 'png':
      return <PngIcon className={className} />;
    case 'jpg':
      return <JpgIcon className={className} />;
    default:
      return <FileIcon className={className} />;
  }
};
